<script setup>

//events raised by component
const emit = defineEmits(["openFilters"])

//local variables
function openFilters() {
	emit('openFilters')
}

</script>

<template>
	<div class="chart-dimension">
		<div class="chart-dimension-row">
			<div>
				<button @click="openFilters" class="btn-tertiary"><span class="icon-settings">
					<i class="fa-regular fa-sliders"></i></span>Customize table</button>
			</div>
		</div>
	</div>	
</template>

<style scoped>
.chart-dimension {
	/* margin: 1.5rem 1.25rem 0.25rem 0; */	
	width: 100%;
	min-width: 0;      /* Crucial for row layouts to allow shrinking */
}

.chart-dimension-row {
	display: flex;
	justify-content: start;
	column-gap: var(--spacing-lg);
	min-width: 0;      /* Crucial for row layouts to allow shrinking */
}

.icon-settings {
	color: var(--icon-cta-Blue);
	margin-right:.5rem;
	min-width: 0;      /* Crucial for row layouts to allow shrinking */
}

.btn-tertiary {
	padding: 0 0.25rem;
	height: 2.5rem;
	white-space: nowrap;
	min-width: 0;      /* Crucial for row layouts to allow shrinking */
}
</style>